{
  "shcUi": {
    "banner": {
      "dismiss": "Odrzuć",
      "inThisCategory": "w tej kategorii"
    },

    "badge": {
      "remove_badge": "Usuń"
    },

    "breadcrumbs": {
      "homeText": "Strona główna"
    },

    "cart": {
      "empty": "Twój koszyk jest pusty",
      "offer": "Wybierz coś z naszej obecnej oferty.",
      "goBackToHomepage": "Strona główna",
      "mini": {
        "cart": "Koszyk",
        "qty": "Ilość",
        "remove": "Usuń",
        "subtotal": "Suma częściowa",
        "shippingAndTaxes": "Koszt dostawy i podatków zostanie obliczony przy kasie.",
        "checkout": "Kasa",
        "continueShopping": "Kontynuuj zakupy",
        "empty": "Twój koszyk jest pusty"
      },
      "product": {
        "tile": {
          "quantity": "Ilość",
          "remove": "Usuń"
        }
      },
      "modal": {
        "title": "Produkt został dodany",
        "yourProduct": "Twój produkt",
        "insideInCart": "znajduje się w koszyku",
        "continueShopping": "Kontynuuj zakupy lub przejdź do podsumowania",
        "continue": "Kontynuuj",
        "goToCart": "Przejdź do koszyka"
      }
    },

    "catalog": {
      "page": {
        "Products": "Produkty",
        "products": "produkty",
        "weHaveGot": "Mamy",
        "inThisCategory": "w tej kategorii"
      }
    },

    "checkout": {
      "summary": {
        "title": "Podsumowanie zamówienia",
        "label": "Kasa"
      },
      "saveContinue": "Zapisz i kontynuuj"
    },

    "copyrights": {
      "content": "Strix. Wszelkie prawa zastrzeżone."
    },

    "dashboard": {
      "title": "Panel",
      "welcome": "Witaj w Twoim koncie!"
    },

    "delivery": {
      "title": "Metody dostawy",
      "info": "Wybierz metodę dostawy."
    },

    "filters": {
      "title": "Filtry",
      "clearAll": "Wyczyść wszystko",
      "price": "cena"
    },

    "footer": {
      "heading": "Stopka",
      "yourEmail": "Twój e-mail",
      "placeholder": "moj{'@'}e-mail.com",
      "subscribe": "Zapisz się",
      "products": "Produkty",
      "company": "Firma",
      "customerService": "Obsługa klienta",
      "newsletterHeading": "Zapisz się na newsletter",
      "newsletterContent": "Najnowsze oferty i oszczędności w Twojej skrzynce e-mail co tydzień.",
      "goto": "Przejdź do"
    },

    "form": {
      "address": {
        "contactLabel": "Dane kontaktowe",
        "email": "Adres email",
        "shippingLabel": "Dane odbiorcy przesyłki",
        "firstName": "Imię",
        "lastName": "Nazwisko",
        "company": "Firma",
        "address": "Adres",
        "street": "Ulica",
        "apartment": "Mieszkanie, apartament itp.",
        "city": "Miasto",
        "country": "Kraj",
        "province": "Powiat",
        "phone": "Telefon",
        "postCode": "Kod pocztowy",
        "saveAndContinue": "Zapisz i kontynuuj",
        "needVatId": "Potrzebujesz faktury do zamówienia?",
        "wantVatId": "Chcę otrzymać fakturę",
        "anotherAddress": "Zamawiasz pod inny adres niż dane odbiorcy?",
        "deferentShippingAddress": "Inny adres dostawy",
        "validator": {
          "required": "To pole jest wymagane",
          "email": "Podaj poprawny adres email.",
          "firstName": "Podaj imię.",
          "lastName": "Podaj nazwisko.",
          "address": "Podaj adres.",
          "apartment": "Podaj mieszkanie, apartament itp.",
          "city": "Podaj nazwę miasta.",
          "country": "Podaj nazwę kraju.",
          "region": "Podaj powiat",
          "postalCode": "Podaj kod pocztowy.",
          "telephone": "Podaj poprawny numer telefonu.",
          "street": "Podaj nazwę ulicy.",
          "config": {
            "emailMinLength": "1",
            "firstNameMinLength": "3",
            "lastNameMinLength": "3",
            "addressMinLength": "3",
            "apartmentMinLength": "1",
            "cityMinLength": "3",
            "countryMinLength": "3",
            "regionMinLength": "3",
            "postalCodeMinLength": "5",
            "telephoneLength": "9"
          }
        }
      },
      "email": {
        "change": {
          "emailAddress": "Adres email",
          "newEmailHelp": "Jeśli chcesz zmienić adres email, wpisz nowy.",
          "changeEmail": "Zmień adres email",
          "emailChangeRequestSent": "Wysłaliśmy wiadomość na obecny adres email w celu potwierdzenia zmiany na nowy.",
          "ok": "OK"
        }
      },
      "login": {
        "title": "Zaloguj się do swojego konta",
        "apply": "Zastosuj",
        "emailAddress": "Adres email",
        "password": "Hasło",
        "rememberMe": "Zapamiętaj mnie",
        "forgotPassword": "Zapomniałeś hasła?",
        "signIn": "Zaloguj się",
        "continueWith": "Lub kontynuuj z",
        "whyHaveAccount": "Dlaczego warto mieć konto?",
        "createAccount": "Utwórz konto"
      },
      "password": {
        "change": {
          "changePassword": "Zmień hasło",
          "enterNewPassword": "Wprowadź nowe hasło.",
          "newPassword": "Nowe hasło",
          "repeatPassword": "Powtórz nowe hasło",
          "placeholder": "Np. name{'@'}example.com",
          "cancel": "Anuluj",
          "passwordChanged": "Twoje hasło zostało zmienione.",
          "ok": "OK"
        },
        "reset": {
          "title": "Zapomniałeś hasła?",
          "info": "Podaj swój adres e-mail poniżej, aby otrzymać link do zresetowania hasło.",
          "send": "Wyślij",
          "confirmation": "Jeśli istnieje konto użytkownika powiązane z wprowadzonym adresem email to zostanie wysłany email z linkiem do zresetowania hasła"
        },
        "create": {
          "title": "Zmiana hasła",
          "send": "Wyślij",
          "confirmation": "Hasło zostało pomyślnie zmienione"
        }
      },
      "register": {
        "email": "Adres e-mail",
        "password": "Hasło",
        "repeat": "Powtórz hasło",
        "minCharacters": "Minimum 6 znaków",
        "firstName": "Imię",
        "lastName": "Nazwisko",
        "company": "Firma",
        "address": "Adres",
        "apartment": "Mieszkanie, apartament itp.",
        "city": "Miasto",
        "country": "Kraj",
        "region": "Powiat",
        "phone": "Telefon",
        "postCode": "Kod pocztowy",
        "createAccount": "Utwórz konto",
        "iHaveAccount": "Posiadam konto",
        "logIn": "Zaloguj się",
        "continueWith": "Lub kontynuuj z",
        "billingInformation": "Informacje dotyczące fakturowania"
      },
      "discount": {
        "discountCode": "Kod rabatowy",
        "apply": "Zastosuj",
        "applied": "Zastosowany",
        "used": "Wykorzystany",
        "invalid": "Nieprawidłowy",
        "withdraw": "Wycofaj",
        "useAnother": "Użyj innego",
        "placeholder": "Wprowadź swój kod rabatowy"
      },
      "contact": {
        "name": "Imię i nazwisko",
        "heading": "Wyślij do nas wiadomość",
        "email": "Adres e-mail",
        "placeholder": "Np. nazwa{'@'}example.com",
        "message": "Wiadomość",
        "sendMessage": "Wyślij wiadomość"
      }
    },

    "header": {
      "closeMenu": "Zamknij menu",
      "shopNow": "Kup teraz",
      "countryCode": "CAD",
      "changeCurrency": ", zmień walutę",
      "openMenu": "Otwórz menu",
      "search": "Szukaj",
      "account": "Konto",
      "viewBag": "Zobacz koszyk",
      "favourites": "Ulubione",
      "all": "Zobacz wszystkie produkty"
    },

    "headerSearch": {
      "contact": "Kontakt"
    },

    "input": {
      "search": {
        "placeholder": "Szukam...",
        "label": "Szukaj"
      }
    },

    "logout": {
      "loggingOut": "Wylogowywanie..."
    },

    "mydata": {
      "title": "Moje Dane"
    },

    "notification": {
      "close": "Zamknij",
      "addedToWishList": "dodano do listy życzeń"
    },

    "offer": {
      "parameter": {
        "inStock": "Dostępne",
        "shipsIn": "Wysyłka w",
        "freeDelivery": "Darmowa wysyłka powyżej 100 zł",
        "freeReturn": "30 dni na darmowy zwrot"
      }
    },

    "order": {
      "details": {
        "orderNo": "Numer zamówienia",
        "date": "Data",
        "total": "Razem",
        "status": "Status",
        "downloadInvoice": "Pobierz fakturę",
        "return": "Zwróć",
        "items": "Produkty",
        "yourInformation": "Twoje dane",
        "paymentMethod": "Metoda płatności",
        "shippingMethod": "Metoda dostawy",
        "summary": "Podsumowanie",
        "orderedProducts": "Zamówione produkty",
        "trackingNo": "Numer śledzenia zamówienia",
        "track": "Śledź swoje zamówienie",
        "yourOrder": "Twoje zamówienie"
      }
    },

    "orders": {
      "title": "Zamówienia",
      "youHave": "Masz",
      "activeOrders": "aktywnych zamówień",
      "noProducts": "Nie zamówiłeś jeszcze żadnych produktów",
      "startShopping": "Zacznij zakupy",
      "table": {
        "no": "Nr",
        "date": "Data",
        "total": "Razem",
        "status": "Status",
        "actions": "Akcje",
        "details": "Szczegóły",
        "return": "Zwróć"
      }
    },

    "page": {
      "error": {
        "message": "błąd",
        "goBackHome": "Wróć do strony głównej"
      }
    },
    "pagination": {
      "prev": "Poprzedni",
      "next": "Następny",
      "summary": {
        "showing": "Wyświetlanie",
        "from": "z"
      }
    },

    "payment": {
      "methods": {
        "title": "Metoda płatności",
        "validationTitle": "Wybierz metodę płatności.",
        "cardNumber": "Numer karty",
        "nameOnCard": "Imię i nazwisko na karcie",
        "expirationDate": "Data ważności (MM/RR)",
        "cvc": "CVC"
      }
    },

    "product": {
      "card": {
        "additionalDetails": "Dodatkowe szczegóły",
        "addToCart": "Dodaj do koszyka",
        "description": "Opis",
        "productInformation": "Informacje o produkcie",
        "reviews": "opinie",
        "sku": "Kod"
      },
      "tile": {
        "reviews": "opinie",
        "addToCart": " Dodaj do koszyka",
        "mini": {
          "quantity": "Ilość",
          "remove": "Usuń"
        }
      }
    },

    "rating": {
      "stars": {
        "reviews": "opinie"
      }
    },

    "select": {
      "chooseOptions": "Wybierz opcje",
      "notifyMe": "Powiadom mnie"
    },

    "sidebar": {
      "navigation": {
        "openNavigation": "Przejdź do konta",
        "closeNavigation": "Zamknij nawigację"
      }
    },

    "stock": {
      "inStock": "W magazynie",
      "leadTime": "3-4 dni",
      "shipsIn": "Wysyłka w"
    },

    "topbar": {
      "contact": "Kontakt"
    },

    "totals": {
      "total": "Razem",
      "subtotal": "Suma częściowa",
      "shipping": "Wysyłka",
      "taxes": "Podatki",
      "discount": "Suma rabatu"
    },

    "languages": {
      "en": "Angielski",
      "pl": "Polski",
      "de": "Niemiecki"
    }
  }
}
